import { apiLoadSettings, apiSaveSettings } from "./baseApi"

// Section name matches the AdminAjax action names exactly:
// load_reschedule_settings / save_reschedule_settings.
export const apiSaveRescheduleSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'reschedule')
}

export const apiLoadRescheduleSettings = (callback) => {
  apiLoadSettings(callback, 'reschedule')
}
